/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useLayoutEffect, useMemo, useState } from "react";
import { IFormData, PaymentProps } from "./Payment.model";
import {
  Autocomplete,
  Box,
  CircularProgress,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import LoadingButtonStyled from "../../atoms/v2/LoadingButton";
import { countries } from "../../../constants/constants";
import { MuiTelInput } from "mui-tel-input";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./Payment.schema";
import { CountryCode } from "libphonenumber-js/types.cjs";

const Payment = (props: PaymentProps) => {
  const defaultCountryNumber = useMemo((): CountryCode => {
    return props.countryCode ?? "DE";
  }, [props.countryCode]);

  const defaultValues = useMemo(() => {
    const defaultCountry = countries.find(
      (country) => country.code === defaultCountryNumber
    );
    const data: IFormData = {
      email: "",
      emailStudent: "",
      firstName: "",
      lastName: "",
      phoneNumberNational: "",
      countryItem: defaultCountry ?? {
        code: "DE",
        label: "Alemania",
      },
    };
    return data;
  }, [countries, defaultCountryNumber]);
  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid, isSubmitting },
  } = useForm({
    defaultValues: defaultValues,
    mode: "all",
    resolver: yupResolver(schema) as any,
  });

  const [phoneNumber, setPhoneNumber] = useState<string>("");

  useLayoutEffect(() => {
    reset(defaultValues);
  }, [defaultValues]);

  const hasDiscount =
    props.priceDetail.totalDiscountPercentPerCode !== 0 ||
    props.priceDetail.totalDiscountPercentPerTimer !== 0;

  const totalPriceWithDiscount =
    props.priceDetail.totalPrice -
    (props.priceDetail.totalDiscountPercentPerCode / 100) *
      props.priceDetail.totalPrice -
    (props.priceDetail.totalDiscountPercentPerTimer / 100) *
      props.priceDetail.totalPrice;

  const custonOnSubmit = useCallback(
    async (data: IFormData) => {
      if (typeof props.onSubmit === "function") {
        await props.onSubmit({
          countryCode: data.countryItem.code,
          email: data.email,
          emailStudent: data.emailStudent,
          firstName: data.firstName,
          lastName: data.lastName,
          phoneNumber: phoneNumber.replace(/\s+/g, ""),
        });
      }
    },
    [props.onSubmit, phoneNumber]
  );

  return (
    <form onSubmit={handleSubmit(custonOnSubmit)}>
      <Stack
        style={{
          display: "flex",
          flexDirection: "column",
        }}
        spacing={4}
      >
        <Stack spacing={2}>
          {hasDiscount ? (
            <img
              style={{
                maxWidth: 150,
                width: "100%",
                alignSelf: "center",
              }}
              src={require("../../../assets/images/firework.png")}
            />
          ) : null}
          <Stack spacing={0.5}>
            <Typography variant="h4" textAlign="center">
              €{totalPriceWithDiscount.toFixed(2)}
            </Typography>
            {hasDiscount ? (
              <Typography variant="body1" textAlign="center">
                Tú ahorras{" "}
                <span style={{ color: "#4caf50" }}>
                  €
                  {(
                    props.priceDetail.totalPrice - totalPriceWithDiscount
                  ).toFixed(2)}{" "}
                  (
                  {(
                    props.priceDetail.totalDiscountPercentPerCode +
                    props.priceDetail.totalDiscountPercentPerTimer
                  ).toFixed()}
                  %)
                </span>
              </Typography>
            ) : null}
          </Stack>
        </Stack>
        <Stack spacing={4}>
          <Typography variant="body1" textAlign="center">
            Completa la siguiente información para iniciar&#160;la&#160;compra
          </Typography>
          <Stack spacing={2}>
            <Typography variant="h5" textAlign="left">
              Alumno
            </Typography>
            <Stack spacing={2}>
              <Controller
                control={control}
                name="emailStudent"
                render={({
                  field: { onBlur, onChange, value },
                  fieldState,
                }) => (
                  <TextField
                    id="outlined-basic"
                    error={!!fieldState.error}
                    label="Correo electrónico"
                    variant="outlined"
                    helperText={
                      !!fieldState.error ? fieldState.error.message : undefined
                    }
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                  />
                )}
              />
            </Stack>
          </Stack>
          <Stack spacing={2}>
            <Typography variant="h5" textAlign="left">
            Titular del pago
            </Typography>
            <Stack spacing={2}>
              <Controller
                control={control}
                name="firstName"
                render={({
                  field: { onBlur, onChange, value },
                  fieldState,
                }) => (
                  <TextField
                    id="outlined-basic"
                    error={!!fieldState.error}
                    label="Nombres del titular"
                    variant="outlined"
                    helperText={
                      !!fieldState.error ? fieldState.error.message : undefined
                    }
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    inputProps={{
                      style: {
                        textTransform: "uppercase",
                      },
                    }}
                  />
                )}
              />
              <Controller
                control={control}
                name="lastName"
                render={({
                  field: { onBlur, onChange, value },
                  fieldState,
                }) => (
                  <TextField
                    id="outlined-basic"
                    error={!!fieldState.error}
                    label="Apellidos del titular"
                    variant="outlined"
                    helperText={
                      !!fieldState.error ? fieldState.error.message : undefined
                    }
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    inputProps={{
                      style: {
                        textTransform: "uppercase",
                      },
                    }}
                  />
                )}
              />
              <Controller
                control={control}
                name="email"
                render={({
                  field: { onBlur, onChange, value },
                  fieldState,
                }) => (
                  <TextField
                    id="outlined-basic"
                    error={!!fieldState.error}
                    label="Correo electrónico"
                    variant="outlined"
                    helperText={
                      !!fieldState.error ? fieldState.error.message : undefined
                    }
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                  />
                )}
              />
              <Controller
                control={control}
                name="countryItem"
                render={({
                  field: { onBlur, onChange, value },
                  fieldState,
                }) => (
                  <Autocomplete
                    id="country-select-demo"
                    options={countries}
                    autoHighlight
                    value={value}
                    onBlur={onBlur}
                    fullWidth={true}
                    onChange={(e, value) => onChange(value)}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) =>
                      option.code === value.code
                    }
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                        <Box
                          key={key}
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...optionProps}
                        >
                          <img
                            loading="lazy"
                            width="20"
                            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                            alt=""
                          />
                          {option.label} ({option.code})
                        </Box>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="País"
                        error={!!fieldState.error}
                        helperText={
                          !!fieldState.error
                            ? fieldState.error.message
                            : undefined
                        }
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password", // disable autocomplete and autofill
                        }}
                      />
                    )}
                  />
                )}
              />
              <Controller
                control={control}
                name="phoneNumberNational"
                render={({
                  field: { onBlur, onChange, value },
                  fieldState,
                }) => (
                  <MuiTelInput
                    error={!!fieldState.error}
                    defaultCountry={defaultCountryNumber}
                    value={phoneNumber}
                    onChange={(newValue, info) => {
                      setPhoneNumber(newValue);
                      if (info.reason === "input") {
                        onChange(info.nationalNumber);
                      }
                    }}
                    placeholder="Número de celular"
                    onBlur={onBlur}
                    forceCallingCode={true}
                    langOfCountryName="es"
                    helperText={
                      !!fieldState.error ? fieldState.error.message : undefined
                    }
                  />
                )}
              />
            </Stack>
          </Stack>
        </Stack>
        <LoadingButtonStyled
          type="submit"
          loading={isSubmitting}
          loadingIndicator={<CircularProgress color="primary" size={24} />}
          disabled={isValid === false}
          variant="contained"
        >
          Pagar €{totalPriceWithDiscount.toFixed(2)}
        </LoadingButtonStyled>
      </Stack>
    </form>
  );
};

export { Payment };
